module.exports = __webpack_public_path__ + "img/contactus_normal_cn@2x.23c385db.png";